import { render, staticRenderFns } from "./water-quality.vue?vue&type=template&id=2d49be8e&scoped=true"
import script from "./water-quality.vue?vue&type=script&lang=js"
export * from "./water-quality.vue?vue&type=script&lang=js"
import style0 from "./water-quality.vue?vue&type=style&index=0&id=2d49be8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49be8e",
  null
  
)

export default component.exports